import type { ShowcaseContentItemDto } from '@repo/api/web/models'

import type { InfoCmsSlug } from '../constants/cmsPages'

/**
 * CMS-материал для страницы модуля `Info` по зарезервированному слагу
 * (MR 12a). Материала нет или он снят с публикации — возвращаем `null`,
 * а страница показывает встроенный текст шаблона: юридические документы
 * не должны исчезать с витрины из-за незаполненной CMS.
 *
 * Ошибку загрузки намеренно не пробрасываем в `createError`: 404 здесь —
 * штатная ситуация «админ ещё не переопределил страницу».
 */
export async function useInfoCmsPage(slug: InfoCmsSlug) {
  const { service } = useContent()

  const { data: item } = await useAsyncData<ShowcaseContentItemDto | null>(
    `info-cms-${slug}`,
    () => service.getBySlug(slug).catch(() => null),
  )

  const hasCmsContent = computed(() => Boolean(item.value?.bodyJson))

  return { item, hasCmsContent }
}
